import "./Brand.css";

export default function BrandMarquee() {
  return (
    <section className="brand-marquee">
      <div className="marquee-track">
        {/* BRAND ITEMS */}
        <div className="brand-item">
          <img src="/suppliers/Agrimore.jpeg" alt="Agrimore" />
        </div>

        <div className="brand-item">
          <img src="/suppliers/nafees.jpeg" alt="Nafees" />
        </div>

        <div className="brand-item">
          <img src="/suppliers/croptech.jpeg" alt="Croptech" />
        </div>

        <div className="brand-item">
          <img src="/suppliers/AQ.png" alt="AQ" />
        </div>

        <div className="brand-item">
          <img src="/suppliers/Agrimore.jpeg" alt="Agrimore" />
        </div>

        <div className="brand-item">
          <img src="/suppliers/nafees.jpeg" alt="Agrimore" />
        </div>

        <div className="brand-item">
          <img src="/suppliers/croptech.jpeg" alt="Croptech" />
        </div>

        <div className="brand-item">
          <img src="/suppliers/AQ.png" alt="AQ" />
        </div>

        {/* DUPLICATE FOR INFINITE LOOP */}
        <div className="brand-item">
          <img src="/suppliers/Agrimore.jpeg" alt="Agrimore" />
        </div>

        <div className="brand-item">
          <img src="/suppliers/nafees.jpeg" alt="Nafees" />
        </div>

        <div className="brand-item">
          <img src="/suppliers/croptech.jpeg" alt="Croptech" />
        </div>

        <div className="brand-item">
          <img src="/suppliers/AQ.png" alt="AQ" />
        </div>

        <div className="brand-item">
          <img src="/suppliers/Agrimore.jpeg" alt="Agrimore" />
        </div>

        <div className="brand-item">
          <img src="/suppliers/nafees.jpeg" alt="Agrimore" />
        </div>

        <div className="brand-item">
          <img src="/suppliers/croptech.jpeg" alt="Croptech" />
        </div>

        <div className="brand-item">
          <img src="/suppliers/AQ.png" alt="AQ" />
        </div>
      </div>
    </section>
  );
}
